import React, { useState, useEffect } from 'react';
import { DndProvider, useDrag, useDrop } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

const ItemType = 'WORD';

const DropSpan = ({ id, expected, onDrop, droppedWord, onRemove }) => {

    const [{ isOver, canDrop }, dropRef] = useDrop(() => ({
        accept: ItemType,
        drop: (item) => onDrop(item.word, expected, id),
        collect: (monitor) => ({
            isOver: monitor.isOver(),
            canDrop: monitor.canDrop(),
        }),
    }));

    return (
        <span
            ref={dropRef}
            className={`drop ${isOver ? 'hover' : ''} ${droppedWord ? 'active' : ''}`}
            onClick={() => onRemove(id)}
            style={{
                cursor: droppedWord ? 'pointer' : 'default',
            }}
        >
        {droppedWord ? droppedWord.name : <b>___</b>}
        </span>
    );

};

const DraggableWord = ({ word }) => {
  const [{ isDragging }, dragRef] = useDrag(() => ({
    type: ItemType,
    item: { word },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  }));

  return (
    <label
      ref={dragRef}
      className="radio"
      
    >
      {word}
    </label>
  );
};

export default function Missing({ v, onChange, showAnswers, student_answer }) {
  const [drops, setDrops] = useState(student_answer || []);
  const [keywords, setKeywords] = useState([]);

  useEffect(() => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(v?.answers, 'text/html');
    const missingEls = Array.from(doc.querySelectorAll('.missingAnswer'));
    const words = missingEls.map((el) => el.textContent.trim());
    setKeywords(words.sort(() => Math.random() - 0.5));
  }, [v?.answers]);

  useEffect(() => {

    let ck = drops?.filter(r => !r?.right);
    let right = true;
    if (ck?.length) {
      right = false;
    }
    
    if (typeof onChange != 'undefined') onChange({ID: v?.ID, answers: drops, right: right});

  }, [drops]);

  const handleDrop = (draggedWord, expected, id) => {
    const right = draggedWord === expected;
    setDrops((prev) => {
      const newDrops = [...prev];
      newDrops[id] = { name: draggedWord, right };
      return newDrops;
    });
  };

  const handleRemoveDrop = (id) => {
    if (student_answer) return false;
    setDrops((prev) => {
      const newDrops = [...prev];
      newDrops[id] = null;
      return newDrops;
    });
  };

  const renderWithDropSpans = () => {
  const container = document.createElement('div');
  container.innerHTML = v?.answers; // v is the original HTML string

  const missingEls = Array.from(container.querySelectorAll('.missingAnswer'));
  const expectedWords = missingEls.map((el) => el.textContent.trim());

  // Replace each .missingAnswer with a placeholder span
  missingEls.forEach((el, i) => {
    const placeholder = document.createElement('span');
    placeholder.setAttribute('data-drop-index', i.toString());
    el.replaceWith(placeholder);
  });

  const htmlWithPlaceholders = container.innerHTML;

  const htmlParts = htmlWithPlaceholders.split(/<span data-drop-index="(\d+)"><\/span>/g);

  return htmlParts.map((part, i) => {
    if (i % 2 === 0) {
      // Render raw HTML part directly — no span wrapper
      return (
        <React.Fragment key={`html-${i}`} >
          <span dangerouslySetInnerHTML={{ __html: part }} />
        </React.Fragment>
      );
    } else {
      const dropId = parseInt(part, 10);
      return (
        <DropSpan
          key={`drop-${dropId}`}
          id={dropId}
          expected={expectedWords[dropId]}
          droppedWord={drops[dropId]}
          onDrop={handleDrop}
          onRemove={handleRemoveDrop}
        />
      );
    }
  });
};


  if (showAnswers) {
    return (
    <div className="answerBoxMissing">
        <div className="missingTxt" dangerouslySetInnerHTML={{__html: v?.answers}}></div>

    </div>
    );
  } else {
      return (
            <DndProvider backend={HTML5Backend}>
                <div className="answerBoxMissing">
                    <div className="missingTxt">{renderWithDropSpans()}</div>
                    <div className="missingWords" style={{ marginTop: 20 }}>
                        {keywords.map((word, i) => {
                            const used = drops.some((d) => d?.name === word);
                            return !used ? <DraggableWord key={i} word={word} /> : null;
                        })}
                    </div>
                </div>
            </DndProvider>
      );
  }
}
